export default "__VITE_ASSET__bZxk7jTw__"